"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedTimeParts = exports.FormattedDateParts = exports.FormattedDisplayName = exports.FormattedList = exports.FormattedNumber = exports.FormattedTime = exports.FormattedDate = exports.defineMessage = exports.defineMessages = void 0;
__exportStar(require("./src/types"), exports);
function defineMessages(msgs) {
    return msgs;
}
exports.defineMessages = defineMessages;
function defineMessage(msg) {
    return msg;
}
exports.defineMessage = defineMessage;
var createFormattedComponent_1 = require("./src/components/createFormattedComponent");
var injectIntl_1 = require("./src/components/injectIntl");
Object.defineProperty(exports, "injectIntl", { enumerable: true, get: function () { return injectIntl_1.default; } });
Object.defineProperty(exports, "RawIntlProvider", { enumerable: true, get: function () { return injectIntl_1.Provider; } });
Object.defineProperty(exports, "IntlContext", { enumerable: true, get: function () { return injectIntl_1.Context; } });
var useIntl_1 = require("./src/components/useIntl");
Object.defineProperty(exports, "useIntl", { enumerable: true, get: function () { return useIntl_1.default; } });
var provider_1 = require("./src/components/provider");
Object.defineProperty(exports, "IntlProvider", { enumerable: true, get: function () { return provider_1.default; } });
Object.defineProperty(exports, "createIntl", { enumerable: true, get: function () { return provider_1.createIntl; } });
// IMPORTANT: Explicit here to prevent api-extractor from outputing `import('./src/types').CustomFormatConfig`
exports.FormattedDate = createFormattedComponent_1.createFormattedComponent('formatDate');
exports.FormattedTime = createFormattedComponent_1.createFormattedComponent('formatTime');
exports.FormattedNumber = createFormattedComponent_1.createFormattedComponent('formatNumber');
exports.FormattedList = createFormattedComponent_1.createFormattedComponent('formatList');
exports.FormattedDisplayName = createFormattedComponent_1.createFormattedComponent('formatDisplayName');
exports.FormattedDateParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatDate');
exports.FormattedTimeParts = createFormattedComponent_1.createFormattedDateTimePartsComponent('formatTime');
var createFormattedComponent_2 = require("./src/components/createFormattedComponent");
Object.defineProperty(exports, "FormattedNumberParts", { enumerable: true, get: function () { return createFormattedComponent_2.FormattedNumberParts; } });
var relative_1 = require("./src/components/relative");
Object.defineProperty(exports, "FormattedRelativeTime", { enumerable: true, get: function () { return relative_1.default; } });
var plural_1 = require("./src/components/plural");
Object.defineProperty(exports, "FormattedPlural", { enumerable: true, get: function () { return plural_1.default; } });
var message_1 = require("./src/components/message");
Object.defineProperty(exports, "FormattedMessage", { enumerable: true, get: function () { return message_1.default; } });
var utils_1 = require("./src/utils");
Object.defineProperty(exports, "createIntlCache", { enumerable: true, get: function () { return utils_1.createIntlCache; } });
__exportStar(require("./src/error"), exports);
